//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash'
import { Bus as VuedalsRadio } from 'vuedals'
import { mapGetters, mapMutations, mapState } from 'vuex'

import GroupDetails from './group-details'

export default {
    data() {
        return {
            backGroupImage: null,
            frontGroupImage: null,
            changingImage: false,

            presentedGroupIds: [],
            modalOpen: false,
        }
    },

    computed: {
        isFeelingLucky() {
            return _.isEmpty(this.lfgTargetGroupTypes)
        },

        targetGroupImages() {
            // Shuffle between every group image if we're in feeling lucky mode
            if (this.isFeelingLucky) return _.map(this.groupTypeList, groupType => this.getGenericGroupImage(groupType))

            return _.map(this.lfgTargetGroupTypes, (options, groupTypeId) => {
                const groupType = this.groupTypes[parseInt(groupTypeId)]
                return this.getGenericGroupImage(groupType)
            })
        },

        ...mapGetters(['getGenericGroupImage', 'groupsList', 'groupTypeList', 'groupIsFull']),
        ...mapState({
            groupTypes: state => state.groups.groupTypes,
            lfgTargetGroupTypes: state => state.groups.lfgTargetGroupTypes,
        }),
    },

    methods: {
        changeGroupImage() {
            if (!this.backGroupImage) {
                this.backGroupImage = _.sample(this.targetGroupImages)
                this.frontGroupImage = _.sample(this.targetGroupImages)
            } else {
                this.changingImage = true
                setTimeout(() => {
                    this.frontGroupImage = _.sample(this.targetGroupImages)
                    this.changingImage = false
                    setTimeout(() => {
                        this.backGroupImage = this.frontGroupImage
                    }, 500)
                }, 500)
            }
        },

        openPotentialGroupIfExists() {
            if (this.modalOpen || !this.lfgTargetGroupTypes) return

            const potentialGroupIds = _.chain(this.groupsList)
                .filter((group) => {
                    // Ignore any groups they've skipped
                    if (this.presentedGroupIds.includes(group.id)) return false

                    // Ignore any full groups
                    if (this.groupIsFull(group)) return false

                    // Check if the user is feelin' lucky
                    if (this.isFeelingLucky) return true

                    // Check if the user is looking for this group type
                    const targetGroup = this.lfgTargetGroupTypes[group.type]
                    if (!targetGroup) return false

                    // Check if the options match what they chose
                    if (!_.isEmpty(targetGroup)) {
                        let allOptionsMatch = true
                        _.each(targetGroup, (optionValues, optionId) => {
                            if (!optionValues.includes(group.options[optionId])) {
                                allOptionsMatch = false
                                return false
                            }
                        })

                        if (!allOptionsMatch) return false
                    }

                    return true
                })
                .map('id')
                .value()

            if (potentialGroupIds.length) {
                const groupId = _.sample(potentialGroupIds)
                this.presentedGroupIds.push(groupId)
                this.$present(GroupDetails, { groupId })
                this.modalOpen = true
            }
        },

        markModalOpen() {
            this.modalOpen = true
        },

        markModalClosed() {
            this.modalOpen = false
        },

        ...mapMutations(['stopLookingForGroups']),
    },

    watch: {
        lfgTargetGroupTypes(targetGroupTypes) {
            if (targetGroupTypes) {
                this.changeGroupImage()
                if (!this.$imageInterval) this.$imageInterval = setInterval(this.changeGroupImage, 3000)
                this.openPotentialGroupIfExists()
            } else {
                this.backGroupImage = null
                this.frontGroupImage = null
                this.presentedGroupIds = []
                clearInterval(this.$imageInterval)
                this.$imageInterval = null
            }
        },

        groupsList() {
            if (this.lfgTargetGroupTypes === null) return
            this.openPotentialGroupIfExists()
        },

        modalOpen(isOpen) {
            if (!isOpen) setTimeout(this.openPotentialGroupIfExists, 1000)
        },
    },

    created() {
        VuedalsRadio.$on('opened', this.markModalOpen)
        VuedalsRadio.$on('dismissed', this.markModalClosed)
        VuedalsRadio.$on('closed', this.markModalClosed)
    },

    beforeDestroy() {
        VuedalsRadio.events.opened = _.without(VuedalsRadio.events.opened, this.markModalOpen)
        VuedalsRadio.events.dismissed = _.without(VuedalsRadio.events.dismissed, this.markModalClosed)
        VuedalsRadio.events.closed = _.without(VuedalsRadio.events.closed, this.markModalClosed)
    },
}
